import Loadable from 'react-loadable';

import { LoadableLoadingPage } from 'pages/LoadableLoadingPage';

export const ContentPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ContentPageContainer" */
      './ContentPageContainer.dynamic'
    ),
  loading: LoadableLoadingPage,
});
